import { render, staticRenderFns } from "./NsLoyaltyInformation.vue?vue&type=template&id=5d6e7cfb&scoped=true&"
import script from "./NsLoyaltyInformation.vue?vue&type=script&lang=js&"
export * from "./NsLoyaltyInformation.vue?vue&type=script&lang=js&"
import style0 from "./NsLoyaltyInformation.vue?vue&type=style&index=0&id=5d6e7cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e7cfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6e7cfb')) {
      api.createRecord('5d6e7cfb', component.options)
    } else {
      api.reload('5d6e7cfb', component.options)
    }
    module.hot.accept("./NsLoyaltyInformation.vue?vue&type=template&id=5d6e7cfb&scoped=true&", function () {
      api.rerender('5d6e7cfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsLoyaltyInformation.vue"
export default component.exports